import "./App.scss";
import { Router } from "./__product__/navigation/router";
import AppHook from "./AppHook";
function App() {
  AppHook();
  /**
   * render build method
   */
  return Router();
}

export default App;
